"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parallelAsync = exports.removeAll = exports.remove = exports.clone = exports.clear = exports.addRange = exports.contains = void 0;
function contains(arr, item) { return arr.indexOf(item) > -1; }
exports.contains = contains;
function addRange(arr, range) { arr.push(...range); }
exports.addRange = addRange;
function clear(arr) {
    arr.length = 0;
}
exports.clear = clear;
function clone(arr) { return [...arr]; }
exports.clone = clone;
function remove(arr, item) {
    const i = arr.indexOf(item);
    if (i >= 0) {
        arr.splice(i, 1);
        return true;
    }
    return false;
}
exports.remove = remove;
function removeAll(arr, valueOrPredicate) {
    const predicate = isPredicate(valueOrPredicate)
        ? valueOrPredicate
        : (item => item === valueOrPredicate);
    let removedCount = 0;
    for (let i = arr.length - 1; i >= 0; i--) {
        if (predicate(arr[i], i)) {
            arr.splice(i, 1);
            removedCount++;
        }
    }
    return removedCount;
}
exports.removeAll = removeAll;
function isPredicate(arg) {
    return typeof arg === 'function';
}
/**
 * Executes an asynchronous function in parallel for all elements of the array.
 * @param func A function that returns a Promise for each item.
 * @param exceptUndefined Whether to exclude undefined results from the output (default: true).
 */
function parallelAsync(list, func, exceptUndefined = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = list.map(func);
        const results = yield Promise.all(promises);
        return exceptUndefined
            ? results.filter((r) => r !== undefined)
            : results;
    });
}
exports.parallelAsync = parallelAsync;
//# sourceMappingURL=array.js.map